import classNames from 'classnames';
import React, {ReactElement} from 'react';

import Breadcrumbs, {CrumbLinkProps} from 'nav/Breadcrumbs';

export interface SidepanelHeaderProps {
  crumbs: Array<ReactElement<CrumbLinkProps>>;
  compact: boolean;
  headerButtons?: React.ReactNode;
  settingsIcon?: React.ReactNode;
  rootText?: string;
  onGoToRoot?: () => void;
}

export default function SidepanelHeader(props: SidepanelHeaderProps): JSX.Element {
  const crumbs = props.crumbs;
  const sliceIndex = props.compact ? 1 : crumbs.length - 1;

  return (
    <div className="u-width-full">
      <div className="u-flex-display">
        <div className="u-flex-grow u-vertical-center-items">
          <Breadcrumbs
            className={classNames({
              'breadcrumbs--large': props.compact,
              'breadcrumbs--gray': !props.compact,
            })}
            crumbs={crumbs.slice(0, Math.max(1, sliceIndex))}
            settingsIcon={crumbs.length <= 1 ? props.settingsIcon : null}
            showTrailingDivider={!props.compact}
          />
        </div>
        {props.headerButtons}
      </div>
      {crumbs.length > 1 && (
        <Breadcrumbs
          className={classNames('u-tiny-spacing-top', 'u-flex-display', {
            'breadcrumbs--large': !props.compact,
          })}
          crumbs={crumbs.slice(sliceIndex)}
          settingsIcon={props.settingsIcon}
        />
      )}
    </div>
  );
}
